"use strict";
export var MinChannelPriorty = 100;
